import React from "react";
import { Button } from "@/components/ui/button";
import { Calendar, Mail } from "lucide-react";
import {
  generateGoogleCalendarUrl,
  generateOutlookCalendarUrl,
  generateICSContent,
} from "@/services/calendar/calendarService";
import { Reservation } from "@/models/storeModel";
import { useTranslation } from "react-i18next";

interface CalendarIntegrationProps {
  reservation: Reservation;
  storeName: string;
}

export function CalendarIntegration({
  reservation,
  storeName,
}: CalendarIntegrationProps) {
  const { t } = useTranslation();
  const handleDownloadICS = () => {
    const icsContent = generateICSContent(reservation, storeName);
    const blob = new Blob([icsContent], {
      type: "text/calendar;charset=utf-8",
    });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.setAttribute("download", `reservation-${reservation.id}.ics`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleGoogleCalendar = () => {
    const url = generateGoogleCalendarUrl(reservation, storeName);
    window.open(url, "_blank");
  };

  const handleOutlookCalendar = () => {
    const url = generateOutlookCalendarUrl(reservation, storeName);
    window.open(url, "_blank");
  };

  return (
    <div className="gap-4 flex flex-wrap items-center justify-center">
      <Button
        variant="outline"
        className="flex items-center gap-2 border border-orange-300 shadow-md"
        onClick={handleGoogleCalendar}
      >
        <Calendar className="h-4 w-4" />
        {t("reservationBooking.calendar.google")}
      </Button>

      <Button
        variant="outline"
        className="flex items-center gap-2 border border-blue-300 shadow-md"
        onClick={handleOutlookCalendar}
      >
        <Mail className="h-4 w-4" />

        {t("reservationBooking.calendar.outlook")}
      </Button>

      <Button
        variant="outline"
        className="flex items-center gap-2 border border-green-300 shadow-md"
        onClick={handleDownloadICS}
      >
        <Calendar className="h-4 w-4" />
        {t("reservationBooking.calendar.download")}
      </Button>
    </div>
  );
}
